import React, { useMemo, useState } from 'react';
import MapSection from '../components/MapSection';
import { lawyersData } from '../data/lawyers';

const ExploreByStatePage = () => {
  const [selectedState, setSelectedState] = useState('');
  const [selectedLawyers, setSelectedLawyers] = useState([]);

  const states = useMemo(() => {
    return Object.keys(lawyersData).slice().sort((a, b) => a.localeCompare(b));
  }, []);

  const handleStateClick = (stateName) => {
    setSelectedState(stateName);
    const lawyers = lawyersData[stateName] || [];
    const sortedLawyers = [...lawyers].sort((a, b) => {
      if (a.backOfficeClient && !b.backOfficeClient) return -1;
      if (!a.backOfficeClient && b.backOfficeClient) return 1;
      if (a.isPremium && !b.isPremium) return -1;
      if (!a.isPremium && b.isPremium) return 1;
      return 0;
    });
    setSelectedLawyers(sortedLawyers);
  };

  return (
    <div className="directory-page">
      <div className="container">
        <div className="section-header">
          <h1 className="section-title">Buscar por Estado</h1>
          <p className="section-description">
            Selecciona un estado para ver los profesionales y empresas disponibles.
          </p>
        </div>

        <div className="contact-form-container" style={{ marginBottom: 24 }}>
          <div className="form-group">
            <label className="form-label" htmlFor="stateSelect">
              Estado
            </label>
            <select
              id="stateSelect"
              className="form-select"
              value={selectedState}
              onChange={(e) => handleStateClick(e.target.value)}
            >
              <option value="">Selecciona un estado</option>
              {states.map((st) => (
                <option key={st} value={st}>
                  {st}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <MapSection
        onStateClick={handleStateClick}
        selectedState={selectedState || null}
        selectedLawyers={selectedLawyers}
        showHeader={false}
        useContainer={true}
      />
    </div>
  );
};

export default ExploreByStatePage;
